import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { HomeProject } from '@models/swagger';
import { ApiService, DefaultHttpHeaders } from '@services/api/api.service';

export interface GetProjectByIdParams extends DefaultHttpHeaders {
  projectQuoteId: string;
  version: string;
}

@Injectable()
export class GetProjectByIdService extends ApiService {
  constructor(protected readonly injector: Injector) {
    super(injector);
  }

  /**
   * Obtain project by id
   * Obtain project by id
   * https://d2go64w4712gob.cloudfront.net/swagger/apis_trasversales/italia/api_Verti.html#/Project/getProjectQuoteById
   */
  getProjectById(params: GetProjectByIdParams): Observable<HomeProject> {
    const queryParams = {
      version: params.version,
    };

    const pathParams = {
      projectQuoteId: params.projectQuoteId,
    };
    return this.get<HomeProject>({
      suffix: `/home/project/${pathParams.projectQuoteId}`,
      queryParams,
      authenticationType: 'jwt',
    });
  }
}
